import module from './gift-deets.module';
import './gift-deets.controller';
import './services/gift-details.service';
import './services/gift-comments.service';
import './gift-deets.style.scss';

export default module.name;